import React from 'react'
import { defaultCTA } from 'src/modules/utils/constants'
import { networkLogos, ratePlanCodes } from 'src/constants'
import { PlanCards } from '../PlanCards'

const willowCricketPromoImg =
  'https://assets-imgx.fubo.tv/marketing/lp/images/card/cricket-card-img.png'

const cardListItems = () => [
  { available: true, text: 'Willow and Willow Xtra' },
  {
    available: true,
    text: '24/7 cricket matches, news & more',
  },
  { available: true, text: 'Every IPL and ICC match' },
  { available: true, text: '18 South Asian channels' },
  { available: true, text: 'Unlimited Cloud DVR' },
]

const cardAddOnInfo = {
  title: 'International Sports Plus add-on includes:',
  logos: [
    'https://assets-imgx.fubo.tv/marketing/lp/images/networks/willow-logo-v3.png',
    'https://assets-imgx.fubo.tv/marketing/lp/images/networks/willow-extra-logo-v3.png',
    networkLogos.tyc.logoWhite,
    networkLogos.goltv.logoWhite,
  ],
}

const cardNetworkLogos = [
  {
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/willow-logo-v3.png',
    alt: networkLogos.willow.alt,
    width: 100,
    height: 40,
  },
  {
    logo: 'https://assets-imgx.fubo.tv/marketing/lp/images/networks/willow-extra-logo-v3.png',
    alt: networkLogos.willow_extra.alt,
    width: 151,
    height: 30,
  },
  { alt: '+ MORE' },
]

const zeeFamilyPlanData = [
  {
    promoImg: willowCricketPromoImg,
    offerCode: ratePlanCodes.zee_family_qt,
    ctaText: defaultCTA.us.noTrial.text,
    plan: 'zee_family',
    subtitle: 'Willow TV & Zee Family',
    title: 'Quarterly',
    price: 45,
    discountedPrice: 30,
    asterisk: true,
    banner: 'Save 33% with Quarterly',
    footnote:
      '*Offer valid for the first 3 months. Renews at $45 every 3 months. Additional taxes and fees may apply. Prices subject to change. Cancel anytime.',
    listItems: cardListItems,
    addOnInfo: cardAddOnInfo,
    networkLogos: cardNetworkLogos,
  },
  {
    promoImg: willowCricketPromoImg,
    offerCode: ratePlanCodes.zee_family_mo,
    ctaText: defaultCTA.us.noTrial.text,
    plan: 'zee_family',
    subtitle: 'Willow TV & Zee Family',
    title: 'Monthly',
    price: 15,
    discountedPrice: 9.99,
    asterisk: false,
    footnote:
      'Offer valid for the first month. Renews at $15/mo. Additional taxes and fees may apply. Prices subject to change. Cancel anytime.',
    listItems: cardListItems,
    addOnInfo: cardAddOnInfo,
    networkLogos: cardNetworkLogos,
  },
]

const ZeeFamilyPlanCard = ({ lang, market }) => {
  return <PlanCards plans={zeeFamilyPlanData} lang={lang} market={market} showLengthText={false} />
}

export default ZeeFamilyPlanCard
